export enum TableType {
  ADDRESSE = 'addresse',
  CONTACT = 'contact',
}
